import {Observer} from "mobx-react";
import styled from "styled-components";
import type {Field} from "../../../../../data/models/field/Field";
import type {XyiconFeature} from "../../../../../generated/api/base";
import {colorPalette} from "../../../styles/colorPalette";
import {baseDistance, FLEXCENTER, fontSize, fontWeight} from "../../../styles/styles";
import {getFieldTypeIcons} from "../abstract/SettingsUtils";
import {FieldFormV5} from "./FieldFormV5";

interface IFieldDetailsContentProps {
	readonly selected: Field[];
	readonly typesFeature: XyiconFeature;
}

export const FieldDetailsContentV5 = (props: IFieldDetailsContentProps) => {
	const {selected, typesFeature} = props;

	return (
		<Observer>
			{() => {
				const field = selected[0];

				return (
					<FieldDetailsContainerStyled key={`${field?.refId} ${field?.name}`}>
						{selected.length === 0 && <FieldDetailsContentNoDataStyled>Please select a field.</FieldDetailsContentNoDataStyled>}
						{selected.length === 1 && (
							<>
								<FieldDetailsContentTitleStyled>
									{getFieldTypeIcons(selected[0])}
									<span>details</span>
								</FieldDetailsContentTitleStyled>
								<FieldFormV5
									field={field}
									typesFeature={typesFeature}
								/>
							</>
						)}
					</FieldDetailsContainerStyled>
				);
			}}
		</Observer>
	);
};

const FieldDetailsContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: ${baseDistance.md};
`;

const FieldDetailsContentNoDataStyled = styled.div`
	font-size: ${fontSize.lg};
	color: ${colorPalette.libraryColors.explosive};
	height: 80%;
	width: 100%;
	position: absolute;
	${FLEXCENTER};
`;

const FieldDetailsContentTitleStyled = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: ${baseDistance.sm};

	svg {
		width: 18px;
		height: 18px;
		color: ${colorPalette.gray.c950};

		path {
			stroke-width: 2px;
		}
	}

	span {
		font-size: ${fontSize.lg};
		color: ${colorPalette.gray.c950};
		font-weight: ${fontWeight.bold};
		text-transform: uppercase;
	}
`;
